import React from 'react';
import HeaderLogo from './HeaderLogo';
import HeaderProgressBar from './HeaderProgressBar';
import styles from './style.module.scss';

interface HeaderProps {
  current: number;
  max: number;
  hideProgressBar?: boolean;
  isBhvkLogo: boolean;
}

export const Header: React.FC<HeaderProps> = ({
  current, max, hideProgressBar, isBhvkLogo,
}) => (
  <div className={styles.header}>
    <HeaderLogo isBhvkLogo={ isBhvkLogo}/>
    <div className={styles['centered-content']}>
      {!hideProgressBar && <HeaderProgressBar currentValue={current} maxValue={max}/>}
    </div>
  </div>
);
